import React, { useCallback, useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, makeStyles } from '@material-ui/core';
import { Star } from '@material-ui/icons';

import AnchorLiveFeedStatusBar from '../AnchorLiveFeedStatusBar/AnchorLiveFeedStatusBar';
import GroupShowStore from '../../../../store/GroupShowStore';
import { isSubscribedToGroupShowAnchor } from '../../../../utils/helpers';
import { RootStoreContext } from '../../../../context';
import classnames from 'classnames';


import './css/AnchorLiveFeedHeader.css';
import './css/AnchorLiveFeedHeader.mobile.css';
import LiveBroadcastStore from '../../../../store/LiveBroadcastStore';


const useStyles = makeStyles(() => {
  return { tipButton: { color: '#fff' } };
});

const AnchorLiveFeedHeader = ({
  setTippingModal,
  anchor,
  isAlreadySubscribedToAnchor,
  anchorVideoUrl,
  roomCount,
  broadcasterClosedSession,
  spotlighterClosedSession,
  isGuest,
  user,
  isAnchor,
  history,
}) => {
  const {
    isInGroupShow,
    username,
    groupShowParticipant: {
      anchorDetails,
      participantUsername,
      isFromTempted,
    },
  } = GroupShowStore;
  let isSubscribedToGroupShowParticipant = false;
  const classes = useStyles();
  const context = useContext(RootStoreContext);
  const { tippingStore } = context;

  if (isInGroupShow && anchorDetails) {
    isSubscribedToGroupShowParticipant = isSubscribedToGroupShowAnchor(user, anchorDetails.id);
  }

  const { isSpotlight, spotlights, broadcastingTemptation, isSpotlighting } = LiveBroadcastStore;
  let secondAnchorToTip = {};

  if (spotlights?.length) {
    if (anchor?.username === broadcastingTemptation?.username) {
      secondAnchorToTip = {};
    } else {
      secondAnchorToTip.username = broadcastingTemptation.username;
      secondAnchorToTip.nickname = broadcastingTemptation.nickname;
      secondAnchorToTip.id = broadcastingTemptation.id;
    }
  }

  return (
    <>
      {(anchorVideoUrl || isInGroupShow) && (
        <div className="is-mobile">
          <div className={classnames({
            'broadcast-viewer-header': true,
            'hide': !isAlreadySubscribedToAnchor,
            'no-padding': isAlreadySubscribedToAnchor,
          })}>
            {isAlreadySubscribedToAnchor && (!isSpotlight && !isInGroupShow && !broadcasterClosedSession) && (
              <>
                <Box width={80}>
                  <Button className="already-subscribed" justifyContent="flex-end" width={80}>
                    <Star />
                    Fan
                  </Button>
                </Box>
                <Button
                  className={classes.tipButton}
                  onClick={() => tippingStore.setTippingModal({ name: anchor.name, username: anchor.username, id: anchor.id })}
                >
                  TIP {anchor.name}
                </Button>
              </>
            )}
          </div>
          {isSpotlight && secondAnchorToTip && (
            <div className="broadcast-viewer-header broadcast-viewer-header-spotlight">
              {!isGuest && !isAnchor && (
                <button
                  className="btn btn-red" onClick={() => {
                    tippingStore.setTippingModal({
                      name: anchor.name,
                      username: anchor.username,
                      id: anchor.id,
                    },
                      secondAnchorToTip?.nickname,
                      secondAnchorToTip?.username,
                      secondAnchorToTip?.id,
                      isSpotlight || isSpotlighting,
                    );
                  }}
                >
                  TIP $
                </button>
              )}
            </div>
          )}
          {isInGroupShow && ((anchorDetails.name || anchorDetails.nickname) || isAlreadySubscribedToAnchor) && (
            <div className="broadcast-viewer-header broadcast-viewer-header-participant">
              {!isGuest && !isAnchor && (
                <button
                  className="btn btn-red" onClick={() => {
                    setTippingModal(
                      {
                        username: username || anchor.username,
                        id: anchor?.id,
                      },
                      participantUsername,
                      anchorDetails.nickname,
                      anchorDetails?.id,
                      );
                  }}
                >
                  TIP $
                </button>
              )}
            </div>
          )}
          {!broadcasterClosedSession && !spotlighterClosedSession && (
            <AnchorLiveFeedStatusBar
              anchorDetails={anchorDetails}
              isInGroupShow={isInGroupShow}
              roomCount={roomCount}
            />
          )}
        </div>
      )
      }

    </>
  );
};

export default observer(AnchorLiveFeedHeader);
